import { Skeleton, Typography } from '@mui/material';

import {
    ADDRESS_FIELD,
    BandIdentity,
    BandRow,
    BandSubtitle,
    BandSurface,
    BandTitle,
    EXTERNAL_ID_FIELD,
    LANGUAGE_FIELD,
    MeasuredBandFields,
    PHONE_FIELD,
    ViewMoreButton,
} from './PatientHeaderBand.layout';
import { BandFieldSpec } from './useVisibleFieldCount';

const SKELETON_FIELDS: BandFieldSpec[] = [
    { ...EXTERNAL_ID_FIELD, value: <Skeleton width={56} /> },
    { ...PHONE_FIELD, value: <Skeleton width={120} /> },
    { ...ADDRESS_FIELD, value: <Skeleton width={220} /> },
    { ...LANGUAGE_FIELD, value: <Skeleton width={64} /> },
];

// The band's content before the patient loads: the labels every patient has, with their values
// still to come.
export const PatientHeaderBandSkeletonRow = () => (
    <BandRow>
        <BandIdentity>
            <BandTitle>
                <Typography fontSize='22px' lineHeight='28px'>
                    <Skeleton width={200} />
                </Typography>
            </BandTitle>
            <BandSubtitle>
                <Skeleton width={150} />
            </BandSubtitle>
        </BandIdentity>
        <MeasuredBandFields fields={SKELETON_FIELDS} />
        <ViewMoreButton />
    </BandRow>
);

export const PatientHeaderBandSkeleton = () => (
    <BandSurface>
        <PatientHeaderBandSkeletonRow />
    </BandSurface>
);
